import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {videoPerformance_template} from "../components/templates/videoPerformance_template";

declare var ko: any;
declare var page: any;

export class videoPerformance extends vnModule_knockoutJS {

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected videoPerformance_template: videoPerformance_template;

    protected getModuleName(){

        return "videoPerformance";
    }

    buildContent() : Array<Element>{

        this.videoPerformance_template = new videoPerformance_template( "roi_tool", this.viewModel, this );
        this.template = this.videoPerformance_template;
        return [this.videoPerformance_template.build()];
    }

    public fillPage() : void{

        this.videoPerformance_template.buildDatePickerCalendar();
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/videoPerformance/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.videoPerformance_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.videoPerformance_template.builtTemplate);
            });
        }
    }

    public getListData(): void{

        this.loadingIn(this.videoPerformance_template.builtTemplate.children.namedItem("list-results"));
        this.videoPerformance_template.hideExportButtons();

        let subViewModel = this.videoPerformance_template.getViewModelForRequest();
        let baseApiUrl = '/api/videoPerformance/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.videoPerformance_template.resetSelectedRows();
                obj.videoPerformance_template.validationsList.clearMessages();
                obj.updateList(responseParsed);

                // LOADING : ends
                obj.loadingOut(obj.videoPerformance_template.builtTemplate.children.namedItem("list-results"));
            });
        };
    }

    public getVideoDataForCSV(): void{

        this.loadingIn(this.videoPerformance_template.builtTemplate.children.namedItem("list-results"));

        this.videoPerformance_template.hideExportButtons();

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.videoPerformance_template.getViewModelForRequest();

        let usrReq_url: string = 'api/videoPerformance/videoCSV';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetVideoDataForCSVReturn;
        this.XHRHdl.execute();
    }

    protected onGetVideoDataForCSVReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.videoPerformance_template.validationsList.clearMessages();
                obj.videoPerformance_template.exportVideoDataCSV(responseParsed);
                obj.videoPerformance_template.showExportButtons();

            });

            obj.loadingOut(obj.videoPerformance_template.builtTemplate.children.namedItem("list-results"));

        };
    }


    protected updateFilters(responseParsed: any){

        this.videoPerformance_template.setViewModesItems();
        this.videoPerformance_template.setCountriesItems();
        this.videoPerformance_template.setDevicesItems();
        this.videoPerformance_template.setOperatingSystemsItems();
        this.videoPerformance_template.setPublishStatusItems();
        this.videoPerformance_template.setPlacementItems();
        this.videoPerformance_template.setOutputItems();
        this.videoPerformance_template.setBrandFilterItems(responseParsed.portfolios);
        this.videoPerformance_template.setIntentsFilterItems(responseParsed.postIntents);
        this.videoPerformance_template.setContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.videoPerformance_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
    }

    protected updateList(responseParsed: any) {

        if (this.videoPerformance_template.getTemplateViewModel().viewModeSelected() == "daily"){
            this.videoPerformance_template.setRevenuePermissions(responseParsed.data.revenuePermissions);
            for (let item of responseParsed.data.tableData) {

                if (item.dateData != "Total") {

                    item.dateData = this.formatDate(item.dateData + "T12:00:00");
                }
            }

            this.videoPerformance_template.setDailyData(responseParsed.data.tableData);
        }else {

            // update the paginator
            this.videoPerformance_template.setPaginationTotalCount(responseParsed.totalCount);
            this.videoPerformance_template.setVideoData(responseParsed.data);
        }

        this.videoPerformance_template.showExportButtons();

    }

    protected filterMultipleSelectorOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterDateOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleOnChange(){

        this.resetPageNumber();
        this.getListData();
    }
a
    public dataReorder(id) {

        this.getListData();
    }

    private resetPageNumber(){

        // go back to page 1 in the pagination
        this.videoPerformance_template.resetPageNumber();
    }

    protected paginationOnPageClick(){

        this.getListData();
    }

    protected formatDate(date) {
        
        let weekday = new Array(7);
        weekday[0] = "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thursday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";

        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear(),
            dayOfWeek = weekday[d.getDay()];


        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return dayOfWeek + ', ' + [year, month, day].join('-');
    }
}



// WEBPACK FOOTER //
// ./js/modules/videoPerformance.ts